import { Slide } from "react-reveal";

const CCTVSecurityOffers = () => {
  return (
    <section className="solution-item-section section-spacing-50 world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="solution-offers-container flex">
              <div className="solution-offers-textside">
                <div className="section-head width-600 section-spacing-40 no-padding-top">
                  <p className="section-tag boldTitle">OFFERS</p>
                  <Slide top>
                    <h2 className="section-title ntuna-text-fill">
                      What's Included
                    </h2>
                  </Slide>
                  <p className="section-subtitle font-inter-regular">
                    We don't just install cameras and surveillance systems. We
                    design and implement reliable security systems you can trust
                    everyday, that give you full visibility, control and
                    protection when it matters most.
                  </p>
                </div>
                <div className="section-body">
                  <ul className="offers-list-container">
                    <li className="offers-list">
                      <h3>Security Needs Assessment & Site Planning</h3>
                      <ul>
                        <li>
                          <span>
                            Physical site inspection (indoor & outdoor)
                          </span>
                        </li>
                        <li>
                          <span>
                            Identification of high-risk zones (entry points,
                            cash areas, storage, perimeters)
                          </span>
                        </li>
                        <li>
                          <span>
                            Lighting condition analysis (day vs night
                            performance)
                          </span>
                        </li>
                        <li>
                          <span>
                            Environmental factors (dust, rain, heat exposure)
                          </span>
                        </li>
                        <li>
                          <span>
                            Current infrastructure review (existing systems,
                            cabling, network)
                          </span>
                        </li>
                        <li>
                          <span>
                            Threat profiling (theft, intrusion, internal misuse,
                            operational risks)
                          </span>
                        </li>
                        <li>
                          <span>Coverage mapping and blind spot detection</span>
                        </li>
                        <li>
                          <span>
                            System requirement planning based on usage (home,
                            office, construction site, school, etc.)
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>CCTV System Architecture & Design</h3>
                      <ul>
                        <li>
                          <span>
                            Camera type selection (dome, bullet, PTZ, turret,
                            covert)
                          </span>
                        </li>
                        <li>
                          <span>
                            Resolution planning (HD, Full HD, 4K based on
                            use-case)
                          </span>
                        </li>
                        <li>
                          <span>
                            Field-of-view calculations and coverage angles
                          </span>
                        </li>
                        <li>
                          <span>
                            Camera positioning for maximum visibility and
                            minimal overlap
                          </span>
                        </li>
                        <li>
                          <span>Network layout design (for IP cameras)</span>
                        </li>
                        <li>
                          <span>
                            Storage sizing based on retention needs
                            (days/weeks/months)
                          </span>
                        </li>
                        <li>
                          <span>
                            Bandwidth planning for remote access and streaming
                          </span>
                        </li>
                        <li>
                          <span>
                            Integration planning with other systems (access
                            control, alarms)
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Professional CCTV Installation & Cabling</h3>
                      <ul>
                        <li>
                          <span>
                            Structured cable routing (concealed where possible)
                          </span>
                        </li>
                        <li>
                          <span>
                            Use of high-quality cables (coaxial, Cat6, fiber
                            where needed)
                          </span>
                        </li>
                        <li>
                          <span>Proper labeling and cable management</span>
                        </li>
                        <li>
                          <span>
                            Mounting (walls, ceilings, poles, outdoor fixtures)
                          </span>
                        </li>
                        <li>
                          <span>
                            Weatherproofing for external installations
                          </span>
                        </li>
                        <li>
                          <span>
                            Equipment rack setup (for organized systems)
                          </span>
                        </li>
                        <li>
                          <span>Minimal disruption during installation</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>High-performance Camera Systems</h3>
                      <ul>
                        <li>
                          <span>HD / Full HD / 4K cameras</span>
                        </li>
                        <li>
                          <span>Infrared (IR) night vision</span>
                        </li>
                        <li>
                          <span>Low-light / color night vision options</span>
                        </li>
                        <li>
                          <span>
                            Wide Dynamic Range (WDR) for mixed lighting
                            environments
                          </span>
                        </li>
                        <li>
                          <span>
                            Motion detection and smart tracking (where
                            applicable)
                          </span>
                        </li>
                        <li>
                          <span>Zoom (optical/digital) for large areas</span>
                        </li>
                        <li>
                          <span>Indoor & outdoor camera variants</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Recording, Storage & Footage Management </h3>
                      <ul>
                        <li>
                          <span>DVR / NVR configuration</span>
                        </li>
                        <li>
                          <span>Hard drive installation and optimization</span>
                        </li>
                        <li>
                          <span>
                            Storage planning based on usage (continuous vs
                            motion recording)
                          </span>
                        </li>
                        <li>
                          <span>
                            Footage retention policies (e.g., 7, 14, 30+ days)
                          </span>
                        </li>
                        <li>
                          <span>Backup configurations (where required)</span>
                        </li>
                        <li>
                          <span>Efficient video compression setup</span>
                        </li>
                        <li>
                          <span>Organized playback and retrieval system</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Remote Monitoring & Smart Access</h3>
                      <ul>
                        <li>
                          <span>Mobile app setup (Android & iOS)</span>
                        </li>
                        <li>
                          <span>Remote live viewing configuration</span>
                        </li>
                        <li>
                          <span>Multi-user access control</span>
                        </li>
                        <li>
                          <span>Playback access via mobile and desktop </span>
                        </li>
                        <li>
                          <span>
                            Real-time alerts (motion detection, activity
                            triggers)
                          </span>
                        </li>
                        <li>
                          <span>
                            Secure remote connectivity (port forwarding / cloud
                            setup)
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Access Control & Entry Management Systems</h3>
                      <ul>
                        <li>
                          <span>
                            Biometric systems (fingerprint, facial recognition
                            where applicable)
                          </span>
                        </li>
                        <li>
                          <span>RFID/card-based access systems</span>
                        </li>
                        <li>
                          <span>PIN/password entry systems</span>
                        </li>
                        <li>
                          <span>
                            Door lock integration (magnetic locks, electric
                            strikes)
                          </span>
                        </li>
                        <li>
                          <span>Time-based access permissions</span>
                        </li>
                        <li>
                          <span>Integration with CCTV for event tracking</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Network Security & System Protection</h3>
                      <ul>
                        <li>
                          <span>
                            Secure network configuration for IP cameras
                          </span>
                        </li>
                        <li>
                          <span>
                            Device authentication and password hardening
                          </span>
                        </li>
                        <li>
                          <span>
                            Firewall and router-level protections (basic)
                          </span>
                        </li>
                        <li>
                          <span>
                            Isolation of CCTV network from main business network
                            (where needed)
                          </span>
                        </li>
                        <li>
                          <span>Firmware updates and system hardening</span>
                        </li>
                        <li>
                          <span>
                            Protection against unauthorized remote access
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Power Backup & System Reliability</h3>
                      <ul>
                        <li>
                          <span>
                            UPS (Uninterruptible Power Supply) integration
                          </span>
                        </li>
                        <li>
                          <span>Power load calculation and optimization</span>
                        </li>
                        <li>
                          <span>Surge protection for equipment safety</span>
                        </li>
                        <li>
                          <span>Voltage stabilization where required</span>
                        </li>
                        <li>
                          <span>Backup runtime planning</span>
                        </li>
                        <li>
                          <span>
                            Failover considerations for critical setups
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>System, Testing, Calibration & Quality Assurance</h3>
                      <ul>
                        <li>
                          <span>Camera angle adjustments and fine-tuning</span>
                        </li>
                        <li>
                          <span>Coverage verification (no blind spots)</span>
                        </li>
                        <li>
                          <span>Night/day performance testing</span>
                        </li>
                        <li>
                          <span>Recording and playback testing</span>
                        </li>
                        <li>
                          <span>Remote access validation</span>
                        </li>
                        <li>
                          <span>Access control system testing</span>
                        </li>
                        <li>
                          <span>Full system walkthrough and validation</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>User Training & System Handover</h3>
                      <ul>
                        <li>
                          <span>Live monitoring usage training</span>
                        </li>
                        <li>
                          <span>Playback and footage retrieval guidance</span>
                        </li>
                        <li>
                          <span>Mobile app usage walkthrough</span>
                        </li>
                        <li>
                          <span>Access control system usage</span>
                        </li>
                        <li>
                          <span>Basic troubleshooting steps</span>
                        </li>
                        <li>
                          <span>Admin-level guidance (for larger setups)</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Maintenance, Support & System Optimization</h3>
                      <ul>
                        <li>
                          <span>
                            Preventive maintenance (cleaning, inspections)
                          </span>
                        </li>
                        <li>
                          <span>System health checks</span>
                        </li>
                        <li>
                          <span>Performance optimization</span>
                        </li>
                        <li>
                          <span>Fault detection and resolution</span>
                        </li>
                        <li>
                          <span>Remote or on-site support options</span>
                        </li>
                        <li>
                          <span>Upgrade recommendations over time</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Scalable & Future-ready Security Design</h3>
                      <ul>
                        <li>
                          <span>Expandable system architecture</span>
                        </li>
                        <li>
                          <span>Additional camera integration capability</span>
                        </li>
                        <li>
                          <span>Storage scalability</span>
                        </li>
                        <li>
                          <span>Upgrade-ready infrastructure</span>
                        </li>
                        <li>
                          <span>Integration with future technologies</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Integration with Wider ICT Systems</h3>
                      <ul>
                        <li>
                          <span>Integration with network systems</span>
                        </li>
                        <li>
                          <span>Alignment with office ICT infrastructure</span>
                        </li>
                        <li>
                          <span>Compatibility with existing tools</span>
                        </li>
                        <li>
                          <span>
                            Potential integration with alarms, intercoms, and
                            monitoring systems
                          </span>
                        </li>
                      </ul>
                    </li>
                    
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CCTVSecurityOffers;
